import React, { useState, useEffect } from "react";
import Div from "@jumbo/shared/Div";
import {
  CardContent,
  Typography,
  Button,
  Collapse,
  IconButton,
  Alert,
} from "@mui/material";
import { ROUTES } from "app/utils/constants/routeConstants";
import { Close as CloseIcon } from "@mui/icons-material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ASSET_CODINGPAL } from "app/utils/constants/paths";
import authServices from "app/services/auth-services";
import { ALERT_SEVERITIES } from "app/utils/constants/constants";

const ActivateAccount = () => {
  const navigate = useNavigate();
  const { key } = useParams();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    if (key) {
      authServices
        .activateAccount(key)
        .then((response) => {
          setTimeout(() => {
            navigate(ROUTES.USER_LOGIN);
          }, 2000);
          setSuccess("successfully verified.");
          setOpenAlert(true);
        })
        .catch((error) => {
          setError(error.message);
          setOpenAlert(true);
        });
    }
  }, [key, navigate]);

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setError(null);
    setSuccess(null);
  };

  return (
    <Div
      sx={{
        width: 720,
        maxWidth: "100%",
        margin: "auto",
        p: 4,
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "#f5f7fa",
        }}
      >
        <Div
          sx={{
            mb: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={`${ASSET_CODINGPAL}/verify-email.png`}
            alt="Email Sent"
            width={120}
            height={120}
            style={{ objectFit: "contain" }}
          />
          <Typography
            variant="h3"
            sx={{
              fontWeight: 500,
              mt: 2,
              mb: 2,
              color: "text.primary",
            }}
          >
            Activate Your Account
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "text.secondary",
              maxWidth: 500,
            }}
          >
            Check your registered email for the activation link.
          </Typography>
        </Div>
        <Collapse in={openAlert}>
          <Alert
            severity={
              success ? ALERT_SEVERITIES.SUCCESS : ALERT_SEVERITIES.ERROR
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleCloseAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2, width: "100%", maxWidth: 500 }}
          >
            {success || error}
          </Alert>
        </Collapse>

        {success ? (
          <Div>
            <Div
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                width: "100%",
                maxWidth: 500,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">
                Not redirected to login page?
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(ROUTES.USER_LOGIN)}
              >
                Login
              </Button>
            </Div>

            <Div
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                width: "100%",
                maxWidth: 500,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">
                Having any issue? Write us an email at <b>sai@codingpal.org</b>
              </Typography>
            </Div>
          </Div>
        ) : (
          <Div
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              width: "100%",
              maxWidth: 500,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">
              Having any issue? Write us an email at <b>sai@codingpal.org</b>
            </Typography>
          </Div>
        )}
      </CardContent>
    </Div>
  );
};

export default ActivateAccount;
